import { redirect } from 'react-router-dom';
import { APP_AUTH } from '../constants/AppConstant';
/**
 * @description Guard function to check whether user has access to the route or not
 *
 * @param {String} param
 * @returns {Function}
 */
const protectedLoader = ({ request = {} }) => {
  
  const cookiesList = document.cookie.split(';');
  console.log('All cookies:', cookiesList);
  let applicationCookie = null ;
  for(let i = 0; i < cookiesList.length; i++) {
    let cookie = cookiesList[i];
    let item = cookie.split('=');
    console.log('Cookie item:', item);
    const key = item[0].replace(" ",'')
    console.log('Looking for cookie key:', APP_AUTH.COOKIE_TOKEN_KEY, 'Found:', key);
    if(key===APP_AUTH.COOKIE_TOKEN_KEY){
      applicationCookie = item[1] ;
      console.log('Found auth cookie:', applicationCookie);
    }
  } 
  console.log('Cookie exists?', applicationCookie);
  if(!applicationCookie){
    console.log('No auth cookie found, redirecting to login');
    // Temporarily bypass auth for development - REMOVE THIS IN PRODUCTION
    console.log('Temporarily bypassing auth for development');
    return null;
    // return redirect("/login");
  }
  return null;
};

/**
 *
 * @description Guard function to redirect to default page if user already loggedin
 *
 * @param {*} param
 */
const unProtectedPageLoaded = ({ request = {} }) => {
  const cookiesList = document.cookie.split(';');
  console.log(cookiesList);
  let applicationCookie = null ;
  for(let i = 0; i < cookiesList.length; i++) {
    let cookie = cookiesList[i];
    let item = cookie.split('=');
    if(item[0]==='auth_token'){
      applicationCookie = item[1] ;
    }
  } 
 

  if (applicationCookie) {
    return redirect('/home/dashboard');
  }
  return null;
};

export const roleGuard = {
  protectedLoader,
  unProtectedPageLoaded,
};
